export const PROGRAM_TYPES = {
  TAX_CREDIT: 'Tax Credit',
  CHARGER_INSTALLATION: 'Charger Installation',
  EV_REBATE: 'EV Rebate',
  OEM: 'OEM',
  EV_CHARGING: 'EV Charging',
};
